export enum EventName {
  SET_FORM_VARIANT = 'Set Form Variant',
  SUBMIT_APPLICATION = 'Submit Application',
  SET_LOCALE = 'Set Locale',
  SET_COOKIE_CONSENT = 'Set Cookie Consent'
}

export enum PropName {
  FORM_VARIANT = 'Form Variant',
  LOCALE = 'Locale',
  CHOICE = 'Choice'
}
